import { useState } from "react";
import { ValueMath, WebinarList } from "@/components/WebinarBonus";

const PLANS = {
  annual: { label: "Annuale", price: "€49,99", period: "anno", note: "circa €4,17 al mese · risparmi il 48%" },
  monthly: { label: "Mensile", price: "€7,99", period: "mese", note: "rinnovo ogni mese · senza webinar" },
};

// Plan choice on the home page; remembered so the payment page preselects it.
export const PlanPicker = () => {
  const [plan, setPlan] = useState(() => (localStorage.getItem("a2g_plan") === "monthly" ? "monthly" : "annual"));
  const pick = (id) => { setPlan(id); localStorage.setItem("a2g_plan", id); };
  const p = PLANS[plan];
  return (
    <div className="mt-4" data-testid="landing-plan-picker">
      <div className="grid grid-cols-2 gap-1 rounded-full border border-[#27272A] bg-[#09090B] p-1" role="tablist">
        {Object.entries(PLANS).map(([id, x]) => (
          <button key={id} role="tab" aria-selected={plan === id} onClick={() => pick(id)} data-testid={`landing-plan-${id}`}
            className={`relative rounded-full py-2.5 text-sm font-semibold transition-colors ${plan === id ? "bg-[#D4AF37] text-[#09090B]" : "text-[#B4B4BC] hover:text-[#FAF9F6]"}`}>
            {x.label}{id === "annual" && <span className={`ml-1.5 text-[11px] font-bold ${plan === id ? "text-[#09090B]/70" : "text-[#E5C158]"}`}>-48%</span>}
          </button>
        ))}
      </div>
      {plan === "annual" && <p className="mt-3 text-[11px] font-bold uppercase tracking-wider text-[#E5C158]">Il più scelto</p>}
      <p className="font-serif-el mt-2 text-4xl font-semibold text-[#FAF9F6]" data-testid="landing-plan-price">{p.price}<span className="text-lg font-medium text-[#B4B4BC]">/{p.period}</span></p>
      <p className={`mt-1 text-base ${plan === "annual" ? "text-[#E5C158]" : "text-[#B4B4BC]"}`}>{p.note}</p>
      {plan === "annual" ? (
        <>
          <WebinarList className="mt-4" />
          <ValueMath className="mt-3" />
        </>
      ) : (
        <button onClick={() => pick("annual")} data-testid="landing-monthly-upsell" className="mt-4 w-full rounded-2xl border border-[#D4AF37]/40 bg-[#D4AF37]/[0.06] p-3 text-left text-sm text-[#D4D4D8]">
          Con l'annuale paghi <b className="text-[#E5C158]">€49,99</b> invece di €95,88 e ricevi <b className="text-[#E5C158]">4 webinar (valore €80)</b>. Vedi l'annuale →
        </button>
      )}
    </div>
  );
};
